import { useCallback } from 'react';
import useDuplicateGroup from './useDuplicateGroup';
import { continueDuplicateReview, exitDuplicateReview, } from '../utils/duplicateReview';
/**
 * A path screen's place in the duplicate review: the group it resolves, and
 * `goToNextStep` for once it's resolved, which moves on to the next group or
 * leaves the review after the last. `goToNextStep` returns true so it can be a
 * Success screen's `onContinue`.
 */
const useDuplicateReviewStep = (navigation, { subscriptionIds, step = 0 }) => {
    const group = useDuplicateGroup(subscriptionIds[step]);
    const total = subscriptionIds.length;
    const hasNextStep = step + 1 < total;
    const goToNextStep = useCallback(() => {
        if (hasNextStep) {
            continueDuplicateReview(navigation, { subscriptionIds, step: step + 1 });
        }
        else {
            exitDuplicateReview(navigation);
        }
        return true;
    }, [hasNextStep, navigation, subscriptionIds, step]);
    return { group, step, total, hasNextStep, goToNextStep };
};
export default useDuplicateReviewStep;
